/**
 * Created by adaltojunior on 1/7/15.
 */

Greenmile.DeviceStatistic = Greenmile.DeviceStatistic || {};
Greenmile.DeviceStatistic.Grid = Greenmile.DeviceStatistic.Grid || {};
Greenmile.DeviceStatistic.Grid.Menu = (function () {

    function Menu () {

        Greenmile.Grid.Menu.apply(this, arguments);

        var goToRouteDetail = function (modelDeviceStatistic) {

            var routeId = modelDeviceStatistic.get('route').id;
            var hash = "#/maps/route/" + routeId + "/details";

            if (hash === window.location.hash) {

                var routeDetail = new App.Routers.RouteDetails();
                routeDetail.show(routeId);

            } else {
                window.location = hash;
            }

        };

        this.getItemsToMenu = function (modelDeviceStatistic) {

            var items = [];
            var enabledMenus = this.getEnabledMenu();
            var iconStyle = 'goToMark';

            if (!modelDeviceStatistic.get('route').id) {
                iconStyle = 'goToMarkDisabled';
            }

            var menuRouteDetail = {
                id: 1,
                description: Monet.I18n.getResourcesByKey('deviceStatistic.menu.routeDetails'),
                icon: iconStyle,
                action: function (context, iconStyle) {

                    return function () {
                        context.gridMenu.removeAllMenus();

                        if (iconStyle === 'goToMarkDisabled') {
                            return;
                        }
                        goToRouteDetail(modelDeviceStatistic);

                    };
                }(this, iconStyle)

            };

            if (enabledMenus.indexOf('btn_route_detail_menu') !== -1) {
                items.push(menuRouteDetail);
            }

            return items;

        };

    }

    return Menu;

}());